var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-tab position-relative d-flex align-items-center justify-content-center px-3 py-1 clickable",class:{ active: _vm.active },on:{"click":_vm.click}},[_c('div',[_c('span',{staticClass:"label text-uppercase bold d-flex align-items-center justify-content-center"},[_vm._v(" "+_vm._s(_vm.label)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }